import { render, staticRenderFns } from "./orderPrice.vue?vue&type=template&id=505fd4e4&"
import script from "./orderPrice.vue?vue&type=script&lang=js&"
export * from "./orderPrice.vue?vue&type=script&lang=js&"
import style0 from "./orderPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports